import gql from 'graphql-tag';

export const createWaitingListItem = gql`
  mutation createWaitingListItem($input: CreateWaitingListItemInput!) {
    createWaitingListItem(input: $input) {
      start
    }
  }
`;
